export const CaretRight = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 8L12 24L22 16L12 8Z" fill="currentColor"/>
</svg>`;
